import React, { useContext } from 'react';
import { getAuthFooterLinks } from './helpers';
import { InlineList, InlineListItem } from '../InlineList';
import { SMFooterContext } from '../SMFooterContext';
import CopyRight from '../CopyRight';

export interface AuthedFooterLinksProps {
  domain: string;
  lang: string;
}

const AuthedFooterLinks = ({
  domain = 'surveymonkey',
  lang = 'en',
}: AuthedFooterLinksProps) => {
  const { onetrustBannerEnabled, isPrivateLabel } = useContext(SMFooterContext);
  const links = getAuthFooterLinks(domain, lang, isPrivateLabel);
  return (
    <InlineList noMargin>
      {links.map(item => (
        <InlineListItem key={item.title} href={item.url}>
          {item.title}
        </InlineListItem>
      ))}
      <If condition={!!onetrustBannerEnabled}>
        {/* Onetrust pipes in the text content here */}
        <InlineListItem
          href="#cookiePreferences"
          className="ot-sdk-show-settings"
          data-testid="AuthedFooterLinks__cookiePreferences"
        />
      </If>
      <InlineListItem>
        <CopyRight />
      </InlineListItem>
    </InlineList>
  );
};

export default AuthedFooterLinks;
